export default __webpack_public_path__ + "static/media/switch-1.d9f7e86a.svg";